<template>
  <div class="bg">
    <div class="wrap">
        <p class="result font-blue">支付成功</p>
        <a href="javascript:void(0)" class="result-tips font-blue" @click="toPayOrderList">查询订单信息</a>
        <p class="result-tips"><a href="javascript:void(0)" class="font-blue" @click="download">下载</a>最新版软件</p>
        <a href="javascript:window.close()" class="result-btn">完成</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {
    document.title = 'PC购买入口';
  },
  mounted() {
    document.getElementsByTagName("body")[0].className="bodyWidth";
  },
  beforeDestroy(){
    document.body.removeAttribute("class","bodyWidth");
  },
  methods: {
    toPayOrderList(){
      window.location.href = window.g.payOrderListUrl;
    },
    download(){
      window.location.href = window.g.productDownloadUrl;
    }
  },

};
</script>

<style scoped>
.main{margin-top: 0;margin-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/client/PayFinsh.vue